import React, { useState } from "react";
import { Icon } from "../design-system/Icon";
import { getImpersonation, stopImpersonation } from "../helpers/impersonation";

/**
 * Barra fija superior visible mientras hay una sesión impersonada. Muestra a qué
 * usuario estás viendo y un botón para salir y volver a tu propia cuenta.
 */
const ImpersonationBanner = () => {
  const imp = getImpersonation();
  const [leaving, setLeaving] = useState(false);

  if (!imp) return null;

  const handleExit = async () => {
    if (leaving) return;
    setLeaving(true);
    try {
      await stopImpersonation();
    } catch (_) {
      setLeaving(false);
    }
  };

  return (
    <div
      role="status"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        flexWrap: "wrap",
        padding: "8px 16px",
        background: "var(--kr-warning-600, #b45309)",
        color: "#fff",
        fontSize: 13,
        fontWeight: 500,
        borderBottom: "1px solid rgba(0,0,0,0.15)",
      }}
    >
      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
        <Icon name="Eye" size={16} />
        Estás viendo Kronaly como{" "}
        <strong style={{ fontWeight: 700 }}>{imp.name}</strong>
        <span style={{ opacity: 0.85, fontFamily: "var(--kr-font-mono)" }}>
          ({imp.email})
        </span>
      </span>
      <button
        type="button"
        onClick={handleExit}
        disabled={leaving}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          padding: "4px 12px",
          background: "rgba(255,255,255,0.18)",
          color: "#fff",
          border: "1px solid rgba(255,255,255,0.4)",
          borderRadius: 6,
          fontSize: 13,
          fontWeight: 600,
          cursor: leaving ? "default" : "pointer",
          opacity: leaving ? 0.7 : 1,
        }}
      >
        <Icon name="LogOut" size={15} />
        {leaving ? "Saliendo…" : "Salir"}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
